/**
 * Releases mission — registered in the Atlas Dock but delegates storage to the
 * existing ReleasesTourStep machine in `onboardingState.ts`. Phase 1 is
 * read-only: the ReleasesPage keeps its own tour code untouched.
 *
 * NOTE: Releases today splits its `featureKey` between `'releasesTour'` (card)
 * and `'releases'` (completion gate). Atlas uses `'releases'` so the adapter's
 * `markFeatureCoachCompletedForProduct` continues to hide the card after Atlas
 * finishes the tour. The split is fixed in Phase 3 by writing both keys.
 */
import type { AtlasMission } from '../atlas.types';

export const releasesMission: AtlasMission = {
  id: 'releases-tour',
  title: 'Walk the Releases page',
  description: 'Release calendar, capacity mapping, and sprint plans.',
  kicker: 'Guided tour',
  estimatedMinutes: 3,
  entryRoute: '/releases',
  featureKey: 'releases',
  storage: 'releases',
  steps: [
    {
      id: 'welcome',
      title: 'What is Releases?',
      body: 'Plan release versions, milestone dates, and capacity.',
    },
    {
      id: 'calendar',
      title: 'Release calendar',
      body: 'Grid with release dates by year.',
      anchorId: 'release-calendar-section',
    },
    {
      id: 'mapping',
      title: 'Capacity calendar mapping',
      body: 'Which team calendars feed each release.',
      anchorId: 'capacity-calendar-mapping-section',
    },
    {
      id: 'plans',
      title: 'Release and sprint plans',
      body: 'Drill from a release into its sprints.',
      anchorId: 'release-plan-section',
    },
    {
      id: 'nextForecast',
      title: 'Next stop: Forecast',
      body: 'Plan capacity into releases and sprints on the Forecast dashboard.',
      route: '/forecast',
      primaryLabel: 'Open Forecast →',
    },
  ],
};
